import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedNumber, FormattedMessage } from 'react-intl';

function handleMinimumFractionDigits(value) {
    return parseFloat(value) % 1 === 0 ? 0 : 2;
}

const CartPrice = function(props) {
    const { prefix, price, item, dataTn, currency } = props;

    let itemSetMessage = null;
    if (item.setSize > 1) {
        itemSetMessage = <FormattedMessage id="CartPrice.perSet" defaultMessage="per set" />;
    } else if (item.quantity > 1 || item.hasUnlimitedQuantity) {
        itemSetMessage = <FormattedMessage id="CartPrice.perItem" defaultMessage="per item" />;
    }

    return (
        <span data-tn={`${dataTn}-wrapper`}>
            {prefix}{' '}
            <span data-tn={dataTn}>
                <FormattedNumber
                    value={price}
                    style="currency"
                    currency={currency}
                    minimumFractionDigits={handleMinimumFractionDigits(price)}
                />
            </span>{' '}
            <span data-tn="price-per-item">{itemSetMessage}</span>
        </span>
    );
};

CartPrice.propTypes = {
    currency: PropTypes.string.isRequired,
    prefix: PropTypes.node,
    item: PropTypes.object.isRequired,
    price: PropTypes.number.isRequired,
    dataTn: PropTypes.string.isRequired,
};

export default createFragmentContainer(CartPrice, {
    item: graphql`
        fragment CartPrice_item on Item {
            setSize
            hasUnlimitedQuantity
            quantity
        }
    `,
});
